<template>
  <div class="client-info-card">
    <v-card color="white" height="170" class="client-info-card__v-card px-4 py-4">
      <div class="client-info-card__v-card__header d-flex no-flex align-center justify-space-between">
        <div class="client-info-card__v-card__header--subtitle">
          <span class="text-uppercase text--truncate" v-if="!breakpointXs">{{ cityStateDisplay() }}</span>
          <span class="text-uppercase text--truncate" v-if="breakpointXs">{{
            (item.city + ", " + item.state).slice(0, 15) + "..."
          }}</span>
        </div>
        <div class="icons">
          <v-btn
            width="80"
            height="30"
            color="button-primary"
            :class="{ 'white--text': true }"
            class="mr-4"
            @click="$emit('client-info-card', { action: 'adCode', exporter: item })"
          >
            <span class="font-weight-bold">Ad code</span>
          </v-btn>
          <v-btn icon @click="$emit('client-info-card', { action: 'edit', exporter: item })">
            <v-icon small>far fa-edit</v-icon>
          </v-btn>
          <v-btn icon @click="$emit('client-info-card', { action: 'delete', exporter: item })">
            <v-icon color="error" small>far fa-trash-alt</v-icon>
          </v-btn>
        </div>
      </div>
      <div>
        <v-list-item-content>
          <v-list-item-subtitle
            class="client-info-card__v-card--title text-uppercase secondaryText--text text--truncate pt-2"
            >{{ item.name }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </div>
      <div class="client-info-card__v-card--description">
        <v-list-item-content>
          <v-list-item-subtitle class="secondaryText--text">{{ item.address1 }}</v-list-item-subtitle>
          <v-list-item-subtitle class="secondaryText--text text--truncate">{{ item.address2 }}</v-list-item-subtitle>
        </v-list-item-content>
      </div>
    </v-card>
  </div>
</template>
<script>
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "ClientInfoCard",
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    cityStateDisplay() {
      const cityStateString = this.item.city + ", " + this.item.state;
      if (this.breakpointXs) {
        if (cityStateString.length > 15) {
          return cityStateString.slice(0, 15) + "...";
        }
      } else {
        if (cityStateString.length > 27) {
          return cityStateString.slice(0, 27) + "...";
        }
      }
      return cityStateString;
    }
  }
};
</script>
<style lang="scss">
@import "../../../styles/settings/index";

.client-info-card {
  &__v-card {
    z-index: 4;
    border-radius: 11px;

    &__header {
      &--subtitle {
        font-weight: 500;
        font-size: 12px;
        color: $secondary-text;
      }
    }
    &--title {
      font-weight: 600;
      font-size: 18px;
    }
    &--description {
      font-weight: 500;
      font-size: 13px;
      color: $subscription-card-text;
    }
  }
}
</style>
